var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"top"},[_c('div',{staticClass:"lefts"},[_vm._v(" 营商环境智能监控中心 ")]),_c('div',{staticClass:"rights"},[_c('topnav',{attrs:{"defaultIndex":_vm.defaultIndex}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }